export class Fonction {
  id: string = '';
  locale: any;
  libelle: string = '';
  valeur: string = '';
  mapvaleurlibelle: any;
  commentaire: any;
  publishDate: Date;
  lastUpdatedDate: Date;
  lastUpdateUserId: any;
  addedfields: any;

  constructor() {}
}
